<template>
  <div>
    <el-row>
      <el-col :span="5">
        <el-col :span="3">
          <i title="Select to View Dashboard" class="mdi mdi-apple-airplay" style="margin: 4px 0px 0px 10px; font-size: 18px;"></i>
        </el-col>
        <el-col :span="21">
          <el-select id="dashboardSelect" filterable v-model="selectedItem" placeholder="Select Dashboard" style="float: left; width: 100%;">
            <el-option-group v-for="group in dashboardValues" :key="group.group" :label="group.group">
              <el-option v-for="item in group.options" :key="item.name" :label="item.name" :value="item.name"> </el-option>
            </el-option-group>
          </el-select>
        </el-col>
      </el-col>
      <el-col :span="7">
        <slot name="filters"></slot>
      </el-col>
      <el-col :span="isReportSection ? 0 : 10">
        <slot name="stats"></slot>
      </el-col>
      <el-col :span="isReportSection ? 19 : 2">
        <el-button class="pull-right hiaButton" size="mini" icon="el-icon-document" plain round @click="createReport()">Create Report</el-button>
      </el-col>
    </el-row>
    <component v-if="selectedItem === 'Pro Risk Canvas'" ref="parentComponent" style="margin-top: 20px;" :is="getComponent(selectedItem)" :options="['loadCanvas']" :isDashboard="true" :projectId="projectId"> </component>
    <component ref="parentComponent" style="margin-top: 20px;" v-if="selectedItem !== 'Pro Risk Canvas'" :is="getComponent(selectedItem)" :drgTableIds="drgTableIds" :proRecordIds="proRecordIds" :ascTableIds="ascTableIds" :dashboards="dashboards" :codeTypes="codeTypes" @showModal="showModal" @handleTableCommands="handleTableCommands" @createSpecificReport="createSpecificReport"> </component>
    <el-dialog id="drilldownDialog" :visible.sync="otherDashboardVisible" destroy-on-close width="75%" :title="drilldownParameter.title">
      <component v-if="otherDashboardVisible" key="dashboardComponent" class="dashboard-drilldown" :codeType="drilldownParameter.codeType" :hideDetails="true" ref="parentComponentOther" style="margin-top: 20px;" :is="drilldownParameter.component" :ascTableIds="drilldownParameter.ascTableIds" :drgTableIds="drilldownParameter.drgTableIds" :proRecordIds="drilldownParameter.proRecordIds" :dashboards="dashboards" @handleTableCommands="handleTableCommands"> </component>
    </el-dialog>
  </div>
</template>

<script>
  import IPFindingSummaryWorksheet from './dashboards/IP_FindingSummaryWorksheet.vue'
  import IPFindingSummaryCombined from './dashboards/IP_FindingSummaryCombined.vue'
  import IPFindingSummaryDx from './dashboards/IP_FindingSummaryDx.vue'
  import IPFindingSummaryPx from './dashboards/IP_FindingSummaryPx.vue'
  import IPRebillLog from './dashboards/IP_RebillLog.vue'
  import IPByFacility from './dashboards/IP_ByFacility.vue'
  import IPByServiceLine from './dashboards/IP_ByServiceLine.vue'
  import IPByProject from './dashboards/IP_ByProject.vue'
  import IPByReason from './dashboards/IP_ByReason.vue'
  import IPBasicSummary from './dashboards/IP_BasicSummary.vue'
  import IPByCoder from './dashboards/IP_ByCoder.vue'
  import IPByOriginalAuditor from './dashboards/IP_ByOriginalAuditor.vue'
  import IPByCDIStaff from './dashboards/IP_ByCDIStaff.vue'
  import IPByDrg from './dashboards/IP_ByDrg.vue'
  import IPDx from './dashboards/IP_DxSummary.vue'
  import IPHCC from './dashboards/IP_HCCSummary.vue'
  import IPHCCV28 from './dashboards/IP_HCCSummaryV28.vue'
  import IPPx from './dashboards/IP_PxSummary.vue'
  import IPPsi from './dashboards/IP_ByPSI.vue'
  import IPQMMortality from './dashboards/IP_ByQMMortality.vue'
  import IPQMReadmission from './dashboards/IP_ByQMReadmission.vue'
  import IPDocAssessment from './dashboards/IP_DocAssessment.vue'
  import IPTrending from './dashboards/IP_Trending.vue'
  import IPChecklistSummary from './dashboards/IP_ChecklistSummary.vue'
  import IPActivityAuditResults from './dashboards/IP_ActivityAuditResults.vue'
  import IPActivityAuditByCoder from './dashboards/IP_ActivityAuditByCoder.vue'
  import IPRebuttalsByCoder from './dashboards/IP_RebuttalsByCoder.vue'
  import IPRebuttalsByAuditor from './dashboards/IP_RebuttalsByAuditor.vue'

  import PROBasicSummary from './dashboards/PRO_BasicSummary.vue'
  import PROByFacility from './dashboards/PRO_ByFacility.vue'
  import PROByServiceLine from './dashboards/PRO_ByServiceLine.vue'
  import PROByProject from './dashboards/PRO_ByProject.vue'
  import PROTrending from './dashboards/PRO_Trending.vue'
  import PROTrendingByCoder from './dashboards/PRO_TrendingByCoder.vue'
  import PROByProvider from './dashboards/PRO_ByProvider.vue'
  import PROByCoder from './dashboards/PRO_ByCoder.vue'
  import PROByOriginalAuditor from './dashboards/PRO_ByOriginalAuditor.vue'
  import PROByReason from './dashboards/PRO_ByReason.vue'
  import PROByPatientType from './dashboards/PRO_ByPatientType.vue'
  import PRODx from './dashboards/PRO_DxSummary.vue'
  import PROHCC from './dashboards/PRO_HCCSummary.vue'
  import PROHCCV28 from './dashboards/PRO_HCCSummaryV28.vue'
  import PROCPT from './dashboards/PRO_CPTSummary.vue'
  import PROEM from './dashboards/PRO_EMSummary.vue'
  import PROMOD from './dashboards/PRO_ModSummary.vue'
  import PROFindingSummaryDX from './dashboards/PRO_FindingSummaryDX.vue'
  import PROFindingSummaryCPT from './dashboards/PRO_FindingSummaryCPT.vue'
  import PROFindingSummaryEM from './dashboards/PRO_FindingSummaryEM.vue'
  import PROFindingSummaryMod from './dashboards/PRO_FindingSummaryMod.vue'
  import PROFindingSummaryWorksheet from './dashboards/PRO_FindingSummaryWorksheet.vue'
  import PROFindingSummaryCombined from './dashboards/PRO_FindingSummaryCombined.vue'
  import PRORebillLog from './dashboards/PRO_RebillLog'
  import PROChecklistSummary from './dashboards/PRO_ChecklistSummary.vue'
  import PROActivityAuditResults from './dashboards/PRO_ActivityAuditResults.vue'
  import PROActivityAuditByCoder from './dashboards/PRO_ActivityAuditByCoder.vue'
  import PRORebuttalsByAuditor from './dashboards/PRO_RebuttalsByAuditor.vue'
  import PRORebuttalsByCoder from './dashboards/PRO_RebuttalsByCoder.vue'
  import PROCanvasWrapper from './dashboards/PRO_CanvasWrapper.vue'
  import PROProviderWorksheetSummary from './dashboards/PRO_ProviderWorksheetSummary.vue'

  import OPFindingSummaryWorksheet from './dashboards/OP_FindingSummaryWorksheet.vue'
  import OPFindingSummaryCombined from './dashboards/OP_FindingSummaryCombined.vue'
  import OPFindingSummaryCPT from './dashboards/OP_FindingSummaryCPT.vue'
  import OPFindingSummaryDX from './dashboards/OP_FindingSummaryDX.vue'
  import OPFindingSummaryMod from './dashboards/OP_FindingSummaryMod.vue'
  import OPBasicSummary from './dashboards/OP_BasicSummary.vue'
  import OPByFacility from './dashboards/OP_ByFacility.vue'
  import OPByServiceLine from './dashboards/OP_ByServiceLine.vue'
  import OPByProject from './dashboards/OP_ByProject.vue'
  import OPByPatientType from './dashboards/OP_ByPatientType.vue'
  import OPByCoder from './dashboards/OP_ByCoder.vue'
  import OPByOriginalAuditor from './dashboards/OP_ByOriginalAuditor.vue'
  import OPDx from './dashboards/OP_DxSummary.vue'
  import OPPx from './dashboards/OP_PxSummary.vue'
  import OPCPT from './dashboards/OP_CPTSummary.vue'
  import OPEM from './dashboards/OP_EMSummary.vue'
  import OPII from './dashboards/OP_IISummary.vue'
  import OPSI from './dashboards/OP_SISummary.vue'
  import OPMOD from './dashboards/OP_ModSummary.vue'
  import OPHCC from './dashboards/OP_HCCSummary.vue'
  import OPHCCV28 from './dashboards/OP_HCCSummaryV28.vue'
  import OPbyReason from './dashboards/OP_ByReason.vue'
  import OPTrending from './dashboards/OP_Trending.vue'
  import OPChecklistSummary from './dashboards/OP_ChecklistSummary.vue'
  import OPActivityAuditResults from './dashboards/OP_ActivityAuditResults.vue'
  import OPActivityAuditByCoder from './dashboards/OP_ActivityAuditByCoder.vue'
  import OPRebuttalsByCoder from './dashboards/OP_RebuttalsByCoder.vue'
  import OPRebuttalsByAuditor from './dashboards/OP_RebuttalsByAuditor.vue'

  import ASCFindingSummaryWorksheet from './dashboards/ASC_FindingSummaryWorksheet.vue'
  import ASCFindingSummaryCombined from './dashboards/ASC_FindingSummaryCombined.vue'
  import ASCFindingSummaryCPT from './dashboards/ASC_FindingSummaryCPT.vue'
  import ASCFindingSummaryDX from './dashboards/ASC_FindingSummaryDX.vue'
  import ASCFindingSummaryMod from './dashboards/ASC_FindingSummaryMod.vue'
  import ASCBasicSummary from './dashboards/ASC_BasicSummary.vue'
  import ASCByFacility from './dashboards/ASC_ByFacility.vue'
  import ASCByCoder from './dashboards/ASC_ByCoder.vue'
  import ASCByOriginalAuditor from './dashboards/ASC_ByOriginalAuditor.vue'
  import ASCByPatientType from './dashboards/ASC_ByPatientType.vue'
  import ASCByProject from './dashboards/ASC_ByProject.vue'
  import ASCByReason from './dashboards/ASC_ByReason.vue'
  import ASCByServiceLine from './dashboards/ASC_ByServiceLine.vue'
  import ASCDx from './dashboards/ASC_DxSummary.vue'
  import ASCCPTWithReimb from './dashboards/ASC_CPTWithReimbSummary.vue'
  import ASCCPTWithoutReimb from './dashboards/ASC_CPTWithoutReimbSummary.vue'
  import ASCHCC from './dashboards/ASC_HCCSummary.vue'
  import ASCHCCV28 from './dashboards/ASC_HCCSummaryV28.vue'
  import ASCMOD from './dashboards/ASC_ModSummary.vue'
  import ASCTrending from './dashboards/ASC_Trending.vue'
  import ASCChecklistSummary from './dashboards/ASC_ChecklistSummary.vue'
  import ASCActivityAuditResults from './dashboards/ASC_ActivityAuditResults.vue'
  import ASCActivityAuditByCoder from './dashboards/ASC_ActivityAuditByCoder.vue'
  import ASCRebuttalsByAuditor from './dashboards/ASC_RebuttalsByAuditor.vue'
  import ASCRebuttalsByCoder from './dashboards/ASC_RebuttalsByCoder.vue'

  import { mapState } from 'vuex'
  import csvGenerator from '@/mixins/csvGenerator'

  export default {
    name: 'dashboards',
    components: {
      IPFindingSummaryWorksheet,
      IPFindingSummaryCombined,
      IPFindingSummaryDx,
      IPFindingSummaryPx,
      IPByFacility,
      IPRebillLog,
      IPByServiceLine,
      IPByProject,
      IPByReason,
      IPBasicSummary,
      IPByCoder,
      IPByCDIStaff,
      IPByDrg,
      IPDx,
      IPHCC,
      IPHCCV28,
      IPPx,
      IPPsi,
      IPTrending,
      IPQMMortality,
      IPQMReadmission,
      IPChecklistSummary,
      IPActivityAuditResults,
      IPActivityAuditByCoder,
      IPRebuttalsByCoder,
      IPRebuttalsByAuditor,
      IPByOriginalAuditor,
      PROBasicSummary,
      PROByFacility,
      PROByServiceLine,
      PROByProvider,
      PROByCoder,
      PROByOriginalAuditor,
      PROByReason,
      PROByPatientType,
      PROTrending,
      PROTrendingByCoder,
      PRODx,
      PROHCC,
      PROHCCV28,
      PROCPT,
      PROEM,
      PROMOD,
      PROChecklistSummary,
      PROActivityAuditResults,
      PROActivityAuditByCoder,
      PROFindingSummaryDX,
      PROFindingSummaryCPT,
      PROFindingSummaryEM,
      PROFindingSummaryMod,
      PROFindingSummaryWorksheet,
      PROFindingSummaryCombined,
      PROCanvasWrapper,
      PROProviderWorksheetSummary,
      PROByProject,
      PRORebillLog,
      PRORebuttalsByAuditor,
      PRORebuttalsByCoder,
      OPFindingSummaryWorksheet,
      OPFindingSummaryCombined,
      OPFindingSummaryCPT,
      OPFindingSummaryDX,
      OPFindingSummaryMod,
      OPBasicSummary,
      OPByFacility,
      OPByServiceLine,
      OPByPatientType,
      OPByCoder,
      OPByOriginalAuditor,
      OPDx,
      OPPx,
      OPCPT,
      OPEM,
      OPII,
      OPSI,
      OPMOD,
      OPHCC,
      OPHCCV28,
      OPbyReason,
      OPByProject,
      OPTrending,
      OPChecklistSummary,
      OPActivityAuditResults,
      OPActivityAuditByCoder,
      OPRebuttalsByCoder,
      OPRebuttalsByAuditor,
      ASCFindingSummaryWorksheet,
      ASCFindingSummaryCombined,
      ASCFindingSummaryCPT,
      ASCFindingSummaryDX,
      ASCFindingSummaryMod,
      ASCBasicSummary,
      ASCByFacility,
      ASCByCoder,
      ASCByOriginalAuditor,
      ASCByPatientType,
      ASCByProject,
      ASCByReason,
      ASCByServiceLine,
      ASCDx,
      ASCCPTWithReimb,
      ASCCPTWithoutReimb,
      ASCHCC,
      ASCHCCV28,
      ASCMOD,
      IPDocAssessment,
      ASCTrending,
      ASCChecklistSummary,
      ASCActivityAuditResults,
      ASCActivityAuditByCoder,
      ASCRebuttalsByAuditor,
      ASCRebuttalsByCoder
    },
    props: ['drgTableIds', 'proRecordIds', 'ascTableIds', 'type', 'isReportSection', 'codeTypes', 'dropdowns', 'projectId', 'showLevel2Audit'],
    mixins: [csvGenerator],
    data: function() {
      return {
        myHTML: '',
        selectedItem: null,
        activatedType: null,
        otherDashboardVisible: false,
        drilldownParameter: {},
        dashboards: [
          {
            group: 'Findings',
            type: 'ip',
            options: [
              {
                name: 'Inpatient Worksheet Findings Summary',
                component: 'IPFindingSummaryWorksheet',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Code Changes',
            type: 'ip',
            options: [
              {
                name: 'Inpatient Combined Code Change Summary',
                component: 'IPFindingSummaryCombined',
                filteredOnly: false
              },
              {
                name: 'Inpatient Dx Change Summary',
                component: 'IPFindingSummaryDx',
                filteredOnly: false
              },
              {
                name: 'Inpatient Px Change Summary',
                component: 'IPFindingSummaryPx',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Accuracy',
            type: 'ip',
            options: [
              {
                name: 'Inpatient Basic Summary',
                component: 'IPBasicSummary',
                filteredOnly: false
              },
              {
                name: 'IP By Facility',
                component: 'IPByFacility',
                filteredOnly: false
              },
              {
                name: 'IP By Project',
                component: 'IPByProject',
                filteredOnly: false
              },
              {
                name: 'IP By Service Line',
                component: 'IPByServiceLine',
                filteredOnly: false
              },
              {
                name: 'IP By Reason',
                component: 'IPByReason',
                filteredOnly: false
              },
              {
                name: 'IP By Coder',
                component: 'IPByCoder',
                filteredOnly: false
              },
              {
                name: 'IP By Original Auditor',
                component: 'IPByOriginalAuditor',
                filteredOnly: false
              },
              {
                name: 'IP Trending',
                component: 'IPTrending',
                filteredOnly: true
              },
              {
                name: 'IP By CDI Staff',
                component: 'IPByCDIStaff',
                filteredOnly: false
              },
              {
                name: 'IP By DRG',
                component: 'IPByDrg',
                filteredOnly: false
              },
              {
                name: 'IP Rebill Log',
                component: 'IPRebillLog',
                filteredOnly: false
              },
              {
                name: 'IP Dx Summary',
                component: 'IPDx',
                filteredOnly: false
              },
              {
                name: 'IP HCC V24 Summary',
                component: 'IPHCC',
                filteredOnly: false
              },
              {
                name: 'IP HCC V28 Summary',
                component: 'IPHCCV28',
                filteredOnly: false
              },
              {
                name: 'IP Px Summary',
                component: 'IPPx',
                filteredOnly: false
              },
              {
                name: 'IP Documentation Assessment',
                component: 'IPDocAssessment',
                filteredOnly: false
              },
              {
                name: 'Patient Safety Indicators',
                component: 'IPPsi',
                filteredOnly: false
              },
              {
                name: 'Mortality Quality Measures',
                component: 'IPQMMortality',
                filteredOnly: false
              },
              {
                name: 'Readmission Quality Measures',
                component: 'IPQMReadmission',
                filteredOnly: false
              },
              {
                name: 'Inpatient Checklist Summary',
                component: 'IPChecklistSummary',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Activity Audits',
            type: 'ip',
            options: [
              {
                name: 'Inpatient Activity Audit Results',
                component: 'IPActivityAuditResults',
                filteredOnly: false,
                featureFlag: 'activityAuditsEnabled'
              },
              {
                name: 'Inpatient Activity Audits by Coder',
                component: 'IPActivityAuditByCoder',
                filteredOnly: false,
                featureFlag: 'activityAuditsEnabled'
              }
            ]
          },
          {
            group: 'Rebuttals',
            type: 'ip',
            options: [
              {
                name: 'Inpatient Rebuttals By Coder',
                component: 'IPRebuttalsByCoder',
                filteredOnly: false
              },
              {
                name: 'Inpatient Rebuttals By Auditor',
                component: 'IPRebuttalsByAuditor',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Findings',
            type: 'op',
            options: [
              {
                name: 'Outpatient Worksheet Findings Summary',
                component: 'OPFindingSummaryWorksheet',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Code Changes',
            type: 'op',
            options: [
              {
                name: 'Outpatient Combined Code Change Summary',
                component: 'OPFindingSummaryCombined',
                filteredOnly: false
              },
              {
                name: 'Outpatient Dx Change Summary',
                component: 'OPFindingSummaryDX',
                filteredOnly: false
              },
              {
                name: 'Outpatient CPT Change Summary',
                component: 'OPFindingSummaryCPT',
                filteredOnly: false
              },
              {
                name: 'Outpatient Modifier Change Summary',
                component: 'OPFindingSummaryMod',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Accuracy',
            type: 'op',
            options: [
              {
                name: 'Outpatient Basic Summary',
                component: 'OPBasicSummary',
                filteredOnly: false
              },
              {
                name: 'OP By Facility',
                component: 'OPByFacility',
                filteredOnly: false
              },
              {
                name: 'OP By Project',
                component: 'OPByProject',
                filteredOnly: false
              },
              {
                name: 'OP By Patient Type',
                component: 'OPByPatientType',
                filteredOnly: false
              },
              {
                name: 'OP By Coder',
                component: 'OPByCoder',
                filteredOnly: false
              },
              {
                name: 'OP By Original Auditor',
                component: 'OPByOriginalAuditor',
                filteredOnly: false
              },
              {
                name: 'OP Trending',
                component: 'OPTrending',
                filteredOnly: true
              },
              {
                name: 'OP By Service Line',
                component: 'OPByServiceLine',
                filteredOnly: false
              },
              {
                name: 'OP By APC Reason',
                component: 'OPbyReason',
                filteredOnly: false
              },
              {
                name: 'OP By Dx',
                component: 'OPDx',
                filteredOnly: false
              },
              {
                name: 'OP By HCC V24',
                component: 'OPHCC',
                filteredOnly: false
              },
              {
                name: 'OP By HCC V28',
                component: 'OPHCCV28',
                filteredOnly: false
              },
              {
                name: 'OP By Px',
                component: 'OPPx',
                filteredOnly: false
              },
              {
                name: 'OP By CPT',
                component: 'OPCPT',
                filteredOnly: false
              },
              {
                name: 'OP By E/M',
                component: 'OPEM',
                filteredOnly: false
              },
              {
                name: 'OP By I&I',
                component: 'OPII',
                filteredOnly: false
              },
              {
                name: 'OP By S&I',
                component: 'OPSI',
                filteredOnly: false
              },
              {
                name: 'OP By Modifier',
                component: 'OPMOD',
                filteredOnly: false
              },
              {
                name: 'OP Checklist Summary',
                component: 'OPChecklistSummary',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Activity Audits',
            type: 'op',
            options: [
              {
                name: 'OP Activity Audit Results',
                component: 'OPActivityAuditResults',
                filteredOnly: false,
                featureFlag: 'activityAuditsEnabled'
              },
              {
                name: 'OP Activity Audits by Coder',
                component: 'OPActivityAuditByCoder',
                filteredOnly: false,
                featureFlag: 'activityAuditsEnabled'
              }
            ]
          },
          {
            group: 'Rebuttals',
            type: 'op',
            options: [
              {
                name: 'Outpatient Rebuttals By Coder',
                component: 'OPRebuttalsByCoder',
                filteredOnly: false
              },
              {
                name: 'Outpatient Rebuttals By Auditor',
                component: 'OPRebuttalsByAuditor',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Findings',
            type: 'asc',
            options: [
              {
                name: 'Ambulatory Worksheet Findings Summary',
                component: 'ASCFindingSummaryWorksheet',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Code Changes',
            type: 'asc',
            options: [
              {
                name: 'Ambulatory Combined Code Change Summary',
                component: 'ASCFindingSummaryCombined',
                filteredOnly: false
              },
              {
                name: 'Ambulatory Dx Change Summary',
                component: 'ASCFindingSummaryDX',
                filteredOnly: false
              },
              {
                name: 'Ambulatory CPT Change Summary',
                component: 'ASCFindingSummaryCPT',
                filteredOnly: false
              },
              {
                name: 'Ambulatory Modifier Change Summary',
                component: 'ASCFindingSummaryMod',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Accuracy',
            type: 'asc',
            options: [
              {
                name: 'ASC Basic Summary',
                component: 'ASCBasicSummary',
                filteredOnly: false
              },
              {
                name: 'ASC By Facility',
                component: 'ASCByFacility',
                filteredOnly: false
              },
              {
                name: 'ASC By Project',
                component: 'ASCByProject',
                filteredOnly: false
              },
              {
                name: 'ASC By Patient Type',
                component: 'ASCByPatientType',
                filteredOnly: false
              },
              {
                name: 'ASC By Coder',
                component: 'ASCByCoder',
                filteredOnly: false
              },
              {
                name: 'ASC By Original Auditor',
                component: 'ASCByOriginalAuditor',
                filteredOnly: false
              },
              {
                name: 'ASC Trending',
                component: 'ASCTrending',
                filteredOnly: true
              },
              {
                name: 'ASC By Service Line',
                component: 'ASCByServiceLine',
                filteredOnly: false
              },
              {
                name: 'ASC By Reason',
                component: 'ASCByReason',
                filteredOnly: false
              },
              {
                name: 'ASC By Dx',
                component: 'ASCDx',
                filteredOnly: false
              },
              {
                name: 'ASC By HCC V24',
                component: 'ASCHCC',
                filteredOnly: false
              },
              {
                name: 'ASC By HCC V28',
                component: 'ASCHCCV28',
                filteredOnly: false
              },
              {
                name: 'ASC By CPTs With Reimbursement',
                component: 'ASCCPTWithReimb',
                filteredOnly: false
              },
              {
                name: 'ASC By CPTs Without Reimbursement',
                component: 'ASCCPTWithoutReimb',
                filteredOnly: false
              },
              {
                name: 'ASC By Modifier',
                component: 'ASCMOD',
                filteredOnly: false
              },
              {
                name: 'ASC Checklist Summary',
                component: 'ASCChecklistSummary',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Activity Audits',
            type: 'asc',
            options: [
              {
                name: 'ASC Activity Audit Results',
                component: 'ASCActivityAuditResults',
                filteredOnly: false,
                featureFlag: 'activityAuditsEnabled'
              },
              {
                name: 'ASC Activity Audits by Coder',
                component: 'ASCActivityAuditByCoder',
                filteredOnly: false,
                featureFlag: 'activityAuditsEnabled'
              }
            ]
          },
          {
            group: 'Rebuttals',
            type: 'asc',
            options: [
              {
                name: 'ASC Rebuttals By Coder',
                component: 'ASCRebuttalsByCoder',
                filteredOnly: false
              },
              {
                name: 'ASC Rebuttals By Auditor',
                component: 'ASCRebuttalsByAuditor',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Findings',
            type: 'pro',
            options: [
              {
                name: 'Pro Worksheet Findings Summary',
                component: 'PROFindingSummaryWorksheet',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Code Changes',
            type: 'pro',
            options: [
              {
                name: 'Pro Combined Code Change Summary',
                component: 'PROFindingSummaryCombined',
                filteredOnly: false
              },
              {
                name: 'Pro Dx Change Summary',
                component: 'PROFindingSummaryDX',
                filteredOnly: false
              },
              {
                name: 'Pro CPT Change Summary',
                component: 'PROFindingSummaryCPT',
                filteredOnly: false
              },
              {
                name: 'Pro EM Change Summary',
                component: 'PROFindingSummaryEM',
                filteredOnly: false
              },
              {
                name: 'Pro Modifier Change Summary',
                component: 'PROFindingSummaryMod',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Risk Analysis',
            type: 'pro',
            options: [
              {
                name: 'Pro Risk Canvas',
                component: 'PROCanvasWrapper',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Accuracy',
            type: 'pro',
            options: [
              {
                name: 'Provider Basic Summary',
                component: 'PROBasicSummary',
                filteredOnly: false
              },
              {
                name: 'Pro By Coder',
                component: 'PROByCoder',
                filteredOnly: false
              },
              {
                name: 'Pro By Original Auditor',
                component: 'PROByOriginalAuditor',
                filteredOnly: false
              },
              {
                name: 'Coder Trending',
                component: 'PROTrendingByCoder',
                filteredOnly: true
              },
              {
                name: 'Pro By Provider',
                component: 'PROByProvider',
                filteredOnly: false
              },
              {
                name: 'Provider Trending',
                component: 'PROTrending',
                filteredOnly: true
              },
              {
                name: 'Pro By Patient Type',
                component: 'PROByPatientType',
                filteredOnly: false
              },
              {
                name: 'Pro By Facility',
                component: 'PROByFacility',
                filteredOnly: false
              },
              {
                name: 'Pro By Project',
                component: 'PROByProject',
                filteredOnly: true
              },
              {
                name: 'Pro By Service Line',
                component: 'PROByServiceLine',
                filteredOnly: false
              },
              {
                name: 'Pro By Record Reason',
                component: 'PROByReason',
                filteredOnly: false
              },
              {
                name: 'Provider Worksheet Summary',
                component: 'PROProviderWorksheetSummary',
                filteredOnly: false
              },
              {
                name: 'Pro Fee Schedule Rebill Log',
                component: 'PRORebillLog',
                filteredOnly: false
              },
              {
                name: 'Pro By Dx',
                component: 'PRODx',
                filteredOnly: false
              },
              {
                name: 'Pro By HCC V24',
                component: 'PROHCC',
                filteredOnly: false
              },
              {
                name: 'Pro By HCC V28',
                component: 'PROHCCV28',
                filteredOnly: false
              },
              {
                name: 'Pro By CPT',
                component: 'PROCPT',
                filteredOnly: false
              },
              {
                name: 'Pro By E/M',
                component: 'PROEM',
                filteredOnly: false
              },
              {
                name: 'Pro By Modifier',
                component: 'PROMOD',
                filteredOnly: false
              },
              {
                name: 'Pro Checklist Summary',
                component: 'PROChecklistSummary',
                filteredOnly: false
              }
            ]
          },
          {
            group: 'Activity Audits',
            type: 'pro',
            options: [
              {
                name: 'Pro Activity Audit Results',
                component: 'PROActivityAuditResults',
                filteredOnly: false,
                featureFlag: 'activityAuditsEnabled'
              },
              {
                name: 'Pro Activity Audits by Coder',
                component: 'PROActivityAuditByCoder',
                filteredOnly: false,
                featureFlag: 'activityAuditsEnabled'
              }
            ]
          },
          {
            group: 'Rebuttals',
            type: 'pro',
            options: [
              {
                name: 'Pro Rebuttals By Coder',
                component: 'PRORebuttalsByCoder',
                filteredOnly: false
              },
              {
                name: 'Pro Rebuttals By Auditor',
                component: 'PRORebuttalsByAuditor',
                filteredOnly: false
              }
            ]
          }
        ]
      }
    },
    methods: {
      getComponent(name) {
        for (let i = 0; i < this.dashboards.length; i++) {
          const obj = this.dashboards[i].options.find(o => o.name === name)
          if (obj) {
            return obj.component
          }
        }
      },
      createReport() {
        const cacheBuster = new Date().getTime()
        window.localStorage.setItem('showLevel2Audit', this.showLevel2Audit)
        if (this.projectId) {
          window.localStorage.setItem('canvasProjectId', this.projectId)
        } else {
          window.localStorage.removeItem('canvasProjectId')
        }

        if (this.proRecordIds && this.type === 'pro') {
          window.localStorage.setItem('reportIds', this.proRecordIds)
          if (!this.codeTypes) {
            window.localStorage.setItem('codeTypes', '')
          } else {
            window.localStorage.setItem('codeTypes', this.codeTypes)
          }
          window.localStorage.removeItem('reportTitle')
          window.localStorage.setItem('codeTypesDesc', this.getCodeTypeFilters())
          window.localStorage.setItem('isReportSection', this.isReportSection)
          this.worksheetWindow = window.open(`/reports/pro-audit-report?fullscreen=true&dt=${cacheBuster}`, 'Pro Audit Report', 'height=850,width=1600')
        }

        if (this.drgTableIds && this.type === 'ip') {
          window.localStorage.setItem('reportIds', this.drgTableIds)
          window.localStorage.removeItem('reportTitle')
          window.localStorage.setItem('isReportSection', this.isReportSection)
          this.worksheetWindow = window.open(`/reports/inpatient-audit-report?fullscreen=true&dt=${cacheBuster}`, 'Inpatient Audit Report', 'height=850,width=1600')
        }

        if (this.ascTableIds && this.type === 'op') {
          window.localStorage.setItem('reportIds', this.ascTableIds)
          if (!this.codeTypes) {
            window.localStorage.setItem('codeTypes', '')
          } else {
            window.localStorage.setItem('codeTypes', this.codeTypes)
          }
          window.localStorage.removeItem('reportTitle')
          window.localStorage.setItem('codeTypesDesc', this.getCodeTypeFilters())
          window.localStorage.setItem('isReportSection', this.isReportSection)
          this.worksheetWindow = window.open(`/reports/outpatient-audit-report?fullscreen=true&dt=${cacheBuster}`, 'Outpatient Audit Report', 'height=850,width=1600')
        }

        if (this.ascTableIds && this.type === 'asc') {
          window.localStorage.setItem('reportIds', this.ascTableIds)
          if (!this.codeTypes) {
            window.localStorage.setItem('codeTypes', '')
          } else {
            window.localStorage.setItem('codeTypes', this.codeTypes)
          }
          window.localStorage.removeItem('reportTitle')
          window.localStorage.setItem('codeTypesDesc', this.getCodeTypeFilters())
          window.localStorage.setItem('isReportSection', this.isReportSection)
          this.worksheetWindow = window.open(`/reports/ambulatory-audit-report?fullscreen=true&dt=${cacheBuster}`, 'Ambulatory Audit Report', 'height=850,width=1600')
        }
      },
      getCodeTypeFilters() {
        let codeTypeDesc = ''
        if (this.codeTypes) {
          for (let i = 0; i < this.codeTypes.length; i++) {
            // console.log(this.dropdowns)
            const ct = this.dropdowns.codeTypes.list.find(o => o.key === this.codeTypes[i])
            //   this.dropdowns
            if (codeTypeDesc) {
              codeTypeDesc = codeTypeDesc + ', ' + ct.value
            } else {
              codeTypeDesc = ct.value
            }
          }
        }

        return codeTypeDesc
      },
      defaultSelection() {
        if (this.type && this.activatedType !== this.type) {
          this.activatedType = this.type
          switch (this.type) {
            case 'ip':
              this.selectedItem = 'Inpatient Basic Summary'
              break
            case 'op':
              this.selectedItem = 'Outpatient Basic Summary'
              break
            case 'asc':
              this.selectedItem = 'ASC Basic Summary'
              break
            case 'pro':
              this.selectedItem = 'Provider Basic Summary'
              break
          }
        }
      },
      showModal(command) {
        this.drilldownParameter = command
        this.otherDashboardVisible = true
      },
      handleTableCommands(command) {
        const visibleComponent = this.otherDashboardVisible ? 'parentComponentOther' : 'parentComponent'
        if (command.ref === 'ipSummary' || command.ref.includes('opSummary_') || command.ref.includes('proSummary_') || command.ref.includes('ascSummary_')) {
          const component = this.$refs[visibleComponent].$refs[command.ref][0] ? this.$refs[visibleComponent].$refs[command.ref][0].$refs[command.ref] : this.$refs[visibleComponent].$refs[command.ref].$refs[command.ref]
          this.tableToCsv(component, `${command.csvName}.csv`, command.headers, command.excludeHeaders)
          return
        }
        if (command.ref.includes('proFinding_')) {
          this.tableToCsv(this.$refs[visibleComponent].$refs[command.ref], `${command.csvName}.csv`, command.headers, command.excludeHeaders)
          return
        }

        if (command.ref === 'RebuttalsTable') {
          const parentRef = this.$refs[visibleComponent]
          if (parentRef.$children) {
            for (const child of parentRef.$children) {
              const found = child.$refs.RebuttalsTable
              if (found) {
                this.tableToCsv(found.$el, `${command.csvName}.csv`, command.headers, command.excludeHeaders)
                return
              }
            }
          }
        }

        const element = this.$refs[visibleComponent].$refs[command.ref]?.$el ? this.$refs[visibleComponent].$refs[command.ref].$el : this.$refs[visibleComponent].$refs[command.ref][0]?.$el ? this.$refs[visibleComponent].$refs[command.ref][0].$el : this.$refs[visibleComponent].$refs[command.ref]
        this.tableToCsv(element, `${command.csvName}.csv`, command.headers, command.excludeHeaders)
      },
      createSpecificReport(payload) {
        const cacheBuster = new Date().getTime()
        let codeType = []
        let codeTypeDesc = payload.row.codeDesc
        if (payload.row.codeNumber === -1) {
          this.dropdowns.codeTypes.list.forEach(a => codeType.push(a.key))
          codeTypeDesc = 'All'
        } else {
          codeType = [payload.row.codeNumber]
        }

        if (payload.row.accountNumbers && this.type === 'pro') {
          window.localStorage.setItem('reportIds', payload.row.accountNumbers)
          window.localStorage.setItem('reportTitle', payload.title)
          window.localStorage.setItem('codeTypes', codeType)
          window.localStorage.setItem('codeTypesDesc', codeTypeDesc)
          if (this.projectId) {
            window.localStorage.setItem('canvasProjectId', this.projectId)
          } else {
            window.localStorage.removeItem('canvasProjectId')
          }
          this.worksheetWindow = window.open(`/reports/pro-audit-report?fullscreen=true&dt=${cacheBuster}`, 'Pro Audit Report', 'height=850,width=1600')
        }

        if (payload.row.accountNumbers && this.type === 'ip') {
          window.localStorage.setItem('reportIds', payload.row.accountNumbers)
          window.localStorage.setItem('reportTitle', payload.title)
          this.worksheetWindow = window.open(`/reports/inpatient-audit-report?fullscreen=true&dt=${cacheBuster}`, 'Inpatient Audit Report', 'height=850,width=1600')
        }

        if (payload.row.accountNumbers && this.type === 'op') {
          window.localStorage.setItem('reportIds', payload.row.accountNumbers)
          window.localStorage.setItem('reportTitle', payload.title)
          window.localStorage.setItem('codeTypes', codeType)
          window.localStorage.setItem('codeTypesDesc', codeTypeDesc)
          this.worksheetWindow = window.open(`/reports/outpatient-audit-report?fullscreen=true&dt=${cacheBuster}`, 'Outpatient Audit Report', 'height=850,width=1600')
        }

        if (payload.row.accountNumbers && this.type === 'asc') {
          window.localStorage.setItem('reportIds', payload.row.accountNumbers)
          window.localStorage.setItem('reportTitle', payload.title)
          window.localStorage.setItem('codeTypes', codeType)
          window.localStorage.setItem('codeTypesDesc', codeTypeDesc)
          this.worksheetWindow = window.open(`/reports/ambulatory-audit-report?fullscreen=true&dt=${cacheBuster}`, 'Ambulatory Audit Report', 'height=850,width=1600')
        }
      }
    },
    created: function() {},
    updated() {
      // this.groupTeleport()
      // this.searchTeleport()
    },
    computed: {
      ...mapState('managedLists/tenantSetup/', ['tenantSetup']),
      dashboardValues() {
        if (this.type) {
          this.defaultSelection()
          const filteredDashboards = this.dashboards
            .filter(f => this.type === f.type)
            .map(dashboard => ({
              ...dashboard,
              options: [...dashboard.options]
            }))

          if (!this.isReportSection) {
            filteredDashboards.forEach(a => {
              a.options = a.options.filter(f => !f.filteredOnly)
            })
          }

          filteredDashboards.forEach(a => {
            a.options = a.options.filter(opt => {
              if (!opt.featureFlag) return true
              return this.tenantSetup && this.tenantSetup[opt.featureFlag]
            })
          })

          // Only show 'Pro Risk Canvas' if proRiskAnalysis() is true
          if (this.type === 'pro') {
            filteredDashboards.forEach(a => {
              a.options = a.options.filter(opt => {
                if (opt.name === 'Pro Risk Canvas') {
                  return this.proRiskAnalysis()
                }
                return true
              })
            })
          }

          // only show IP By Original Auditor if showLevel2Audit is true
          if (this.type === 'ip' && !this.showLevel2Audit) {
            filteredDashboards.forEach(a => {
              a.options = a.options.filter(opt => opt.name !== 'IP By Original Auditor')
            })
          }

          // only show OP By Original Auditor if showLevel2Audit is true
          if (this.type === 'op' && !this.showLevel2Audit) {
            filteredDashboards.forEach(a => {
              a.options = a.options.filter(opt => opt.name !== 'OP By Original Auditor')
            })
          }

          // only show PRO By Original Auditor if showLevel2Audit is true
          if (this.type === 'pro' && !this.showLevel2Audit) {
            filteredDashboards.forEach(a => {
              a.options = a.options.filter(opt => opt.name !== 'Pro By Original Auditor')
            })
          }

          // only show ASC By Original Auditor if showLevel2Audit is true
          if (this.type === 'asc' && !this.showLevel2Audit) {
            filteredDashboards.forEach(a => {
              a.options = a.options.filter(opt => opt.name !== 'ASC By Original Auditor')
            })
          }

          // hide OP By Px when outpatient PCS auditing is disabled
          if (this.type === 'op' && !this.tenantSetup.enableOutpatientPcsAuditing) {
            filteredDashboards.forEach(a => {
              a.options = a.options.filter(opt => opt.name !== 'OP By Px')
            })
          }

          return filteredDashboards.filter(dashboard => dashboard.options.length > 0)
        }
        return this.dashboards
      }
    },
    watch: {
      type() {
        if (this.type && this.type !== this.activatedType) {
          this.defaultSelection()
        }
      }
    }
  }
</script>

<style scoped>
  >>> .caret-wrapper {
    display: none;
  }

  >>> .el-table th > .cell,
  >>> th {
    word-break: break-word;
  }

  >>> .el-table th {
    vertical-align: top;
  }

  >>> .no-data-message {
    font-size: 12px;
    color: #606266;
  }

  >>> #dashboardSelect {
    height: 30px;
  }

  >>> .el-loading-spinner {
    top: 50px !important;
  }

  #drilldownDialog >>> .el-dialog__body {
    overflow: hidden;
  }

  >>> .tag-danger {
    padding: 2px 8px;
    border-radius: 4px;
    background-color: #fef0f0;
    border-color: #fde2e2;
    color: #f56c6c;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid;
  }

  >>> .tag-success {
    padding: 2px 8px;
    border-radius: 4px;
    background-color: #f2f9ef;
    border-color: #e5f2df;
    font-weight: 600;
    color: #7cbe5f;
    font-size: 12px;
    border: 1px solid;
  }

  >>> .card-flex-row {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  >>> .minimal-card {
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
    background: #fff;
    border: 1px solid #d9dee8;
    border-radius: 4px;
    flex: 1;
    min-height: 64px;
    margin-top: 20px;
    transition: box-shadow 0.3s ease;
  }

  >>> .minimal-card:hover {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  }

  >>> .card-label {
    font-size: 14px;
    color: #4f5661;
    margin-bottom: 6px;
  }

  >>> .card-value {
    font-size: 16px;
    font-weight: 600;
    color: #1f2328;
    line-height: 1.2;
  }

  >>> .card-value-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: auto;
  }

  >>> .minimal-card > .card-value {
    margin-top: auto;
  }
</style>
